export function getHrefBasePath(href: string): string {
    const url = new URL(href);
    let path = url.pathname;
    if (path[path.length - 1] === '/') {
        path = path.substring(0, path.length - 1);
    }
    const pathSegments = path.split('/');
    if (pathSegments[pathSegments.length - 1].includes('.htm')) {
        pathSegments.pop();
        path = pathSegments.join('/');
    }

    // Re-Auth should not end on slash because it should not be handled by service worker.
    // If it ends on slash, the service worker tries to fetch url from cache.
    if (url.port === '7641') {
        path = path + '?sap-client=202';
    }

    return url.origin + path;
}

export function getSharpTicketUri(isEnvironmentProduction: boolean, isPwa: boolean): string {
    return isEnvironmentProduction && !isPwa ? '/api/createsharpticketprod' : '/api/createsharpticket';
}
